import agent from './agent';
import config from '../config.json';
import ServiceBase from './ServiceBase';

const baseUrl = config.baseUrl;
const service = 'journal';

class JournalServiceAgent extends ServiceBase {
    /**
     * Activates user after Clerk signup.
     * @param {string} uid
     * @param {string} tier
     * @returns {Promise}
     */
    activateUser = (uid, tier) => {
        const url = `${baseUrl}/${service}/user/activate`;
        const config = {
            headers: {
                Authorization: `Bearer ${this.getToken()}`,
                'Content-Type': 'application/json',
            },
        };
        return agent.post(url, { uid, tier }, config);
    };

    /**
     * Upsert: empty rk creates a new journal entry, existing rk updates it.
     * @param {{data: object}} dto - data holds { rk?, title, body, format, service, type, cat, stage, stateId, ... }
     * @returns {Promise} response data holds the rk
     */
    createOrUpdate = (dto) => {
        const url = `${baseUrl}/${service}/journal/create`;
        const config = {
            headers: { Authorization: `Bearer ${this.getToken()}` },
        };
        return agent.post(url, dto, config);
    };

    /**
     * @deprecated misleading name, this is an upsert — use createOrUpdate
     * @param {{data: object}} dto
     * @returns {Promise}
     */
    createJournal = (dto) => this.createOrUpdate(dto);
}

const journalService = new JournalServiceAgent();
export default journalService;
